import { Controller } from "@hotwired/stimulus"
import { TempFormHelper } from "~/helpers/temp_form_helper"

// This controller is used to move or copy a company to another company list.
export default class extends Controller {
  static get targets() {
    return ["title", "action", "modalContent"]
  }

  static get values() {
    return {
      selectedCompanyIds: { type: Array, default: [] },
    }
  }

  showModal({ params: { companyListId, url, removeFromList, filterParams } }) {
    const form = TempFormHelper.create(url, "get", (form) => {
      TempFormHelper.addHiddenInput(form, "company_list_id", companyListId)
      TempFormHelper.addHiddenInput(form, "remove_from_list", removeFromList)
      if (this.hasSelectedCompanyIdsValue) {
        this.selectedCompanyIdsValue.forEach(id => TempFormHelper.addHiddenInput(form, "company_ids[]", id))
      }
      if (filterParams) {
        Object.entries(filterParams).forEach(([key, value]) => {
          if (Array.isArray(value)) {
            value.forEach(arrayValue => {
              TempFormHelper.addHiddenInput(form, `${key}[]`, arrayValue)
            })
          } else {
            TempFormHelper.addHiddenInput(form, key, value)
          }
        })
      }
    }, this.modalContentTarget)

    form.requestSubmit()
  }

  updateSelection(event) {
    this.selectedCompanyIdsValue = event.detail.dataSets.map(dataSet => dataSet.recordId).filter(Boolean)
  }
}
